import { BILLPAY_PORTAL_HOSTNAME, REFERRER, RoleType } from "../constants/sharedConstants";

export const getLoggedInPortalDetails = () => {
    const urlFragments = window.location.href.split("/");
    const urlFragmentsWithoutProtocol = urlFragments[2].split(".");
    
    let referrer = '';
    const hostFragment = removeV2FromUrl(urlFragmentsWithoutProtocol[0])
    let fiConfigKey = hostFragment;
    let isV2Site = urlFragmentsWithoutProtocol[0].includes('-v2') ? true : false;
    let queryparams;

    if(hostFragment == BILLPAY_PORTAL_HOSTNAME) {
      queryparams = urlFragments[3].split("&");

      if (queryparams?.[0]?.includes(REFERRER)) {
        let referreValue = queryparams[0].split("=")[1];

        fiConfigKey = joinStrings("-", hostFragment, removeV2FromUrl(referreValue));

        sessionStorage.setItem(REFERRER, referreValue);
        sessionStorage.setItem("ultimateRoute", queryparams?.[1]);
      }

      if(referrer = sessionStorage.getItem(REFERRER)) {
        fiConfigKey = joinStrings("-", hostFragment, removeV2FromUrl(referrer));
      }      
    }

    return {
      hostFragment: hostFragment,
      fiConfigKey: fiConfigKey,
      currentEnv : urlFragmentsWithoutProtocol[1],
      currentDomain: joinStrings(".", urlFragmentsWithoutProtocol[1], urlFragmentsWithoutProtocol[2]),
      isV2Site: isV2Site
    };
}

export const isBillerUserAndPortalType = (userDetailObject, portalType) => {
  return localStorage.getItem("type") === portalType && isBillerUser(userDetailObject.role.role_type);
}

export const isBillerUserAndOneOfPortalTypes = (userDetailObject, portalTypes) => {
  return portalTypes.includes(localStorage.getItem("type")) && isBillerUser(userDetailObject.role.role_type);
}

export const isPortalTypeAndRoles = (portalType, roleTypeOrId, ...allowedRoleObjects) => { // The last argument is role objects (such as RoleType.BILLER_ADMIN, RoleType.WP_FI_USER), not role types
  if (portalType?.startsWith("!") ? localStorage.getItem("type") !== portalType.substring(1).trim() : localStorage.getItem("type") === portalType) {
    return (typeof roleTypeOrId === "number" || !isNaN(roleTypeOrId) && !isNaN(parseInt(roleTypeOrId)))
      ? allowedRoleObjects?.map(r => r.id).includes(Number(roleTypeOrId))
      : allowedRoleObjects?.map(r => r.type).includes(roleTypeOrId);
  }
  return false;
}

export const isAgreeementAccepted = (data, role_type) => {
  let isBillerPadAgreementAccepted = true;

  if (isPortalTypeAndRoles("webportal", role_type, RoleType.BILLER_ADMIN)) {
    isBillerPadAgreementAccepted = data.billerNonVolatileDto?.agreement_accepted == "A";
  } else if (isBillerUserAndPortalType(data, "billpay")) {
    const billerCrossReferenceDto = data.billerCrossReferenceDto;

    isBillerPadAgreementAccepted = !billerCrossReferenceDto || billerCrossReferenceDto?.padAccepted == 'Y';
  }

  return isBillerPadAgreementAccepted;
}

export const populateBillPayPortalDetails = () => {
  const { hostFragment, fiConfigKey: fiConfigKey, currentDomain, isV2Site } = getLoggedInPortalDetails();

  const v2Fragment = isV2Site ? '-v2' : '';

  const referrerFragment = hostFragment != BILLPAY_PORTAL_HOSTNAME ? `?referrer=${hostFragment}${v2Fragment}` : "";

  return {
    fiConfigKey: fiConfigKey,
    billPayPortalUrl: `https://${BILLPAY_PORTAL_HOSTNAME}${v2Fragment}.${currentDomain}${referrerFragment}`
  }
}

export const populateReferrerUrl = () => {
  return `https://${sessionStorage.getItem(REFERRER)}.${getCurrentDomain()}/dashboard`;
}

export const isBillerUser = (roleType) => {
  return roleType == RoleType.BILLER_ADMIN.type || roleType == RoleType.BILLER_USER.type;
}

const removeV2FromUrl = (urlFragment) => {
  return urlFragment.replaceAll('-v2', '');
}

const joinStrings = (separator, ...strings) => {
  return strings.join(separator);
}

const getCurrentDomain = () => {
  const urlFragmentsWithoutProtocol = window.location.href.split("/")[2].split(".");

  return joinStrings(".", urlFragmentsWithoutProtocol[1], urlFragmentsWithoutProtocol[2]);
}
